"use client";
import { Button } from "@/app/_module/components/ui/button";
import {
  Dialog,
  ResponsiveDialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/app/_module/components/ui/dialog";

interface ConfirmDeleteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const ConfirmDeleteModal = function({
  open,
  onOpenChange,
  onConfirm,
}: ConfirmDeleteModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false); // Close modal after confirming
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <ResponsiveDialogContent size="md">
        <DialogHeader>
          <DialogTitle className="pb-4 text-xl font-bold">Delete User</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this user? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button className="px-6 cursor-pointer" onClick={() => onOpenChange(false)} variant="outline">
            Cancel
          </Button>
          <Button className="px-6 cursor-pointer" onClick={handleConfirm} variant="destructive">
            Delete
          </Button>
        </DialogFooter>
      </ResponsiveDialogContent>
    </Dialog>
  );
}

export default ConfirmDeleteModal;
